import { Grid, Alert } from "@mui/material"
import React, { useContext, useEffect } from "react";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "src/hooks/useLoader";
import { EntityWithIdFields, QueryStatus } from "src/types";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  FormOperacionNotaEstructurada,
  OperacionNotaEstructurada,
  schemaFormOperacionNotaEstructurada
} from "./types/types";
import {HttpNotaEstructurada} from "./api/httpNotaEstructurada";
import SeccionNotaEstructuradaDatosOperacion from "./components/SeccionNotaEstructuradaDatosOperacion";
import {useOperacionNotaEstructurada} from "./hooks/useOperacionNotaEstructurada";
import {OperacionNotaEstructuradaFields} from "./types/fields";
import SeccionNotaEstructuradaCuentas from "./components/SeccionNotaEstructuradaCuentas";
import {SeccionFirmas} from "../../components/SeccionFirmas";
import {SistemaTipo} from "../../../../types/enum/enum";
import {useSectoresComerciales} from "../../../messages/api/useSectoresComerciales";

type SistemaNotaEstructuradaContentProps = {
  operacion: OperacionNotaEstructurada,
}

const SistemaNotaEstructuradaContent = ({ operacion }: SistemaNotaEstructuradaContentProps) => {

  const { setSavePromise, permisoTipo, codSistemaTipo: codSistema } = useContext<ContextOperacionType>(ContextOperacion)

  const formMethods = useForm<FormOperacionNotaEstructurada>({
    resolver: zodResolver(schemaFormOperacionNotaEstructurada),
    values: { ...operacion }
  })

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (operacion.permiteEditarOperacion) {
      const handleSave: SubmitHandler<FormOperacionNotaEstructurada> = (data) => {
        showLoader()
        const promise = HttpNotaEstructurada.put(operacion[EntityWithIdFields.Id], data)

        toast.promise(promise, {
          loading: 'Guardando.',
          success: 'Guardado correctamente.',
          error: e => `${e}`
        }).finally(hideLoader)
      }

      const onSave = () => formMethods.handleSubmit(handleSave)
      setSavePromise(onSave)
    }
  }, [])


  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionNotaEstructuradaDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={operacion[OperacionNotaEstructuradaFields.CodPais]}
            codSistema={codSistema}
            readOnly={true}
            operacion={operacion}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionNotaEstructuradaCuentas
            operacionId={operacion[EntityWithIdFields.Id]}
            permiteEditar={operacion.permiteEditarOperacion}
            permiteEliminar={operacion.permiteEliminarOperacion}
            codPais={operacion[OperacionNotaEstructuradaFields.CodPais]}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.NotaEstructurada}
            idOperacion={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
      </Grid>
    </>
  )
}


export const SistemaNotaEstructurada = () => {

  const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion)

  const { status, operacion } = useOperacionNotaEstructurada(idOperacion)

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])

  if (!operacion) {
    return (
      <>{JSON.stringify(operacion)}</>
    )
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaNotaEstructuradaContent
      operacion={operacion}
    />
  )
}
